import React, {useEffect, useState} from 'react';
import XP_ICON from "../../pages/icons/xp-icon.png";
import COIN_ICON from "../../pages/icons/coin-icon.png";
import LVL_ICON from "../../pages/icons/star.png";
import {useTranslation} from "react-i18next";
import {Popover} from "antd";

const AchievementGainedBar = ({level, xp, coins}) => {
	const {t} = useTranslation();
	const [barStats, setBarStats] = useState([]);

	useEffect(() => {
		setBarStats([
			{
				title: t("achievements.earnedLevel"),
				icon: LVL_ICON,
				count: level,
				placement: "topLeft",
				delay: 0
			},
			{
				title: t("achievements.earnedExperience"),
				icon: XP_ICON,
				count: xp,
				placement: "top",
				delay: 350
			},
			{
				title: t("achievements.earnedCoins"),
				icon: COIN_ICON,
				count: coins,
				placement: "topRight",
				delay: 700
			}
		]);
	}, [level, xp, coins]);
	return (
			<div className='grid grid-cols-3 gap-2.5 justify-between'>
				{barStats.map(({title, icon, count, placement, delay}, index) => (
					<Popover
							key={index}
							placement={placement}
							title={title}
							content={null}
					>
						<div
							className='hover:scale-105 transition-all relative flex justify-center items-center gap-2 bg-gradient-to-bl from-violet-500 to-fuchsia-700 text-white rounded-lg p-2 cursor-pointer overflow-hidden'
						>
							<img className='relative w-7 h-7 md:w-10 md:h-10 object-contain z-[1]' src={icon} alt={title}/>
							<h5 className='relative z-[1] text-xl md:text-2xl font-bold'>
								{count ?? 0}
							</h5>
							<span
								className='animate-glass-loop'
								style={{
									animationDelay: `0.${delay}s`,
								}}
							/>
						</div>
					</Popover>
				))}
			</div>
	);
};

export default AchievementGainedBar;